module.exports = __webpack_public_path__ + "static/media/05GalleryPuppets.0387e6de.jpeg";